



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { util, biHottag, language } from '@tencent/ppd-base-libs';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import LoadFailed from '@/components/load-failed.vue';
import { queryBuildingList, queryHomeConfinees } from '../api';
import VHeader from '../components/sub-header.vue';
import { i18n } from '@/i18n';

export enum PageType {
  building = 'building',
  home = 'home',
}

@Component({
  components: { VHeader, LoadFailed },
})
export default class AreaQuery extends Vue {
  @Prop({}) public pageType!: PageType;

  sourceData = [];
  keyword = '';
  loaded = false;
  bannerType = '';
  lang = language.getLanguage();
  loadFailed = false;

  get isBuilding() {
    return this.pageType === 'building';
  }
  get isHome() {
    return this.pageType === 'home';
  }

  get listData() {
    if (this.keyword === '') {
      return this.sourceData.reverse();
    }
    return this.sourceData
      .filter((item) => {
        // @ts-ignore
        const existOnBuilding = item.buildingName.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1;
        if (existOnBuilding) {
          return existOnBuilding;
        }
        // @ts-ignore
        const existOnArea = item.district.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1;
        return existOnArea;
      })
      .reverse();
  }

  get textConf() {
    if (this.isBuilding) {
      return {
        title: i18n('确诊个案曾逗留地查询'),
        dateText: i18n('最後逗留日期'),
      };
    }
    if (this.isHome) {
      return {
        title: i18n('家居检疫个案地区'),
        dateText: i18n('檢疫最後日'),
      };
    }
  }

  handleInputClick() {
    if (this.isBuilding) {
      biHottag('wallet.cvirus.buildings.search_click');
    } else if (this.isHome) {
      biHottag('wallet.cvirus.situation.search_click');
    }
  }

  async activated() {
    showLoading();
    this.loadFailed = false;
    if (this.isBuilding) {
      this.bannerType = this.pageType;
      biHottag('wallet.cvirus.situation.index_brow');
      util.changeTitle(i18n('曾逗留地區'));
      const [err, data] = await util.to(queryBuildingList());
      if (err) {
        hideLoading();
        // showBusinessError(err);
        this.loadFailed = true;
        return;
      }
      this.sourceData = data.f_ncov_data;
    } else if (this.isHome) {
      this.bannerType = this.pageType;
      biHottag('wallet.cvirus.buildings.index_brow');
      util.changeTitle(i18n('家居檢疫個案地區'));
      const [err, data] = await util.to(queryHomeConfinees());
      if (err) {
        hideLoading();
        // showBusinessError(err);
        this.loadFailed = true;
        return;
      }
      this.sourceData = data.f_ncov_data;
    }
    hideLoading();
    this.loaded = true;
  }
  deactivated() {
    this.loaded = false;
    this.sourceData = [];
    this.keyword = '';
    this.bannerType = '';
  }
}
